export const CACHE_ID = "gJ5Drt2CARLOANSCANADA";
export const STEPS_DATA = "stepsData";
export const DEFAULT_TOAST_DURATION = 5000;
export const RESTRICT_PATH = "restrictPath";